<main id="content" role="main">
  <!-- Hero Section -->
  <div id="SVGHero" class="gradient-overlay-half-indigo-v1 position-relative overflow-hidden" style="">
    <div class="container space-2 space-top-md-5 space-top-lg-4">
      <div class="w-lg-60 text-center mx-lg-auto">
        <div class="mb-5">
          <h1 class="display-4 font-size-md-down-5 font-weight-medium mb-3">Audio Visual & Stage Design</h1>
          <h4>We bring passion, creativity and innovation to the industry through high quality event production!</h4>

        </div>

        <button class="btn btn-primary btn-wide transition-3d-hover" type="button" (click)="ctaService.showCTA('17e74dcb-2609-478e-848a-ceffdd2c4df2')">Get a Quote</button>
      </div>
    </div>

    <!-- Mockup -->
    <div class="container space-2">
      <div class="position-relative w-lg-75 text-center mx-lg-auto">
        <div class="position-relative shadow-lg z-index-2 rounded-lg">
          <img class="img-fluid rounded-lg" src="../../assets/website/av-hero.jpg" alt="Image Description">
        </div>

        <figure class="max-width-15 w-100 position-absolute top-0 right-0">
          <div class="mt-n11 mr-n11">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 458 458" style="enable-background:new 0 0 458 458;" xml:space="preserve" class="injected-svg js-svg-injector" data-parent="#SVGHero">
<style type="text/css">
	.dots {
    fill: #2D1582;
  }
</style>
              <circle class="dots fill-indigo" cx="4" cy="4" r="4"></circle>
              <circle class="dots fill-indigo" cx="94" cy="4" r="4"></circle>
              <circle class="dots fill-indigo" cx="184" cy="4" r="4"></circle>
              <circle class="dots fill-indigo" cx="274" cy="4" r="4"></circle>
              <circle class="dots fill-indigo" cx="364" cy="4" r="4"></circle>
              <circle class="dots fill-indigo" cx="454" cy="4" r="4"></circle>
              <circle class="dots fill-indigo" cx="4" cy="94" r="4"></circle>
              <circle class="dots fill-indigo" cx="94" cy="94" r="4"></circle>
              <circle class="dots fill-indigo" cx="184" cy="94" r="4"></circle>
              <circle class="dots fill-indigo" cx="274" cy="94" r="4"></circle>
              <circle class="dots fill-indigo" cx="364" cy="94" r="4"></circle>
              <circle class="dots fill-indigo" cx="454" cy="94" r="4"></circle>
              <circle class="dots fill-indigo" cx="4" cy="184" r="4"></circle>
              <circle class="dots fill-indigo" cx="94" cy="184" r="4"></circle>
              <circle class="dots fill-indigo" cx="184" cy="184" r="4"></circle>
              <circle class="dots fill-indigo" cx="274" cy="184" r="4"></circle>
              <circle class="dots fill-indigo" cx="364" cy="184" r="4"></circle>
              <circle class="dots fill-indigo" cx="454" cy="184" r="4"></circle>
              <circle class="dots fill-indigo" cx="4" cy="274" r="4"></circle>
              <circle class="dots fill-indigo" cx="94" cy="274" r="4"></circle>
              <circle class="dots fill-indigo" cx="184" cy="274" r="4"></circle>
              <circle class="dots fill-indigo" cx="274" cy="274" r="4"></circle>
              <circle class="dots fill-indigo" cx="364" cy="274" r="4"></circle>
              <circle class="dots fill-indigo" cx="454" cy="274" r="4"></circle>
              <circle class="dots fill-indigo" cx="4" cy="364" r="4"></circle>
              <circle class="dots fill-indigo" cx="94" cy="364" r="4"></circle>
              <circle class="dots fill-indigo" cx="184" cy="364" r="4"></circle>
              <circle class="dots fill-indigo" cx="274" cy="364" r="4"></circle>
              <circle class="dots fill-indigo" cx="364" cy="364" r="4"></circle>
              <circle class="dots fill-indigo" cx="454" cy="364" r="4"></circle>
              <circle class="dots fill-indigo" cx="4" cy="454" r="4"></circle>
              <circle class="dots fill-indigo" cx="94" cy="454" r="4"></circle>
              <circle class="dots fill-indigo" cx="184" cy="454" r="4"></circle>
              <circle class="dots fill-indigo" cx="274" cy="454" r="4"></circle>
              <circle class="dots fill-indigo" cx="364" cy="454" r="4"></circle>
              <circle class="dots fill-indigo" cx="454" cy="454" r="4"></circle>
</svg>
          </div>
        </figure>
        <figure class="max-width-15 w-100 position-absolute bottom-0 left-0">
          <div class="mb-n7 ml-n7">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 458 458" style="enable-background:new 0 0 458 458;" xml:space="preserve" class="injected-svg js-svg-injector" data-parent="#SVGHero">
<style type="text/css">
	.dots {
    fill: #2D1582;
  }
</style>
              <circle class="dots fill-indigo" cx="4" cy="4" r="4"></circle>
              <circle class="dots fill-indigo" cx="94" cy="4" r="4"></circle>
              <circle class="dots fill-indigo" cx="184" cy="4" r="4"></circle>
              <circle class="dots fill-indigo" cx="274" cy="4" r="4"></circle>
              <circle class="dots fill-indigo" cx="364" cy="4" r="4"></circle>
              <circle class="dots fill-indigo" cx="454" cy="4" r="4"></circle>
              <circle class="dots fill-indigo" cx="4" cy="94" r="4"></circle>
              <circle class="dots fill-indigo" cx="94" cy="94" r="4"></circle>
              <circle class="dots fill-indigo" cx="184" cy="94" r="4"></circle>
              <circle class="dots fill-indigo" cx="274" cy="94" r="4"></circle>
              <circle class="dots fill-indigo" cx="364" cy="94" r="4"></circle>
              <circle class="dots fill-indigo" cx="454" cy="94" r="4"></circle>
              <circle class="dots fill-indigo" cx="4" cy="184" r="4"></circle>
              <circle class="dots fill-indigo" cx="94" cy="184" r="4"></circle>
              <circle class="dots fill-indigo" cx="184" cy="184" r="4"></circle>
              <circle class="dots fill-indigo" cx="274" cy="184" r="4"></circle>
              <circle class="dots fill-indigo" cx="364" cy="184" r="4"></circle>
              <circle class="dots fill-indigo" cx="454" cy="184" r="4"></circle>
              <circle class="dots fill-indigo" cx="4" cy="274" r="4"></circle>
              <circle class="dots fill-indigo" cx="94" cy="274" r="4"></circle>
              <circle class="dots fill-indigo" cx="184" cy="274" r="4"></circle>
              <circle class="dots fill-indigo" cx="274" cy="274" r="4"></circle>
              <circle class="dots fill-indigo" cx="364" cy="274" r="4"></circle>
              <circle class="dots fill-indigo" cx="454" cy="274" r="4"></circle>
              <circle class="dots fill-indigo" cx="4" cy="364" r="4"></circle>
              <circle class="dots fill-indigo" cx="94" cy="364" r="4"></circle>
              <circle class="dots fill-indigo" cx="184" cy="364" r="4"></circle>
              <circle class="dots fill-indigo" cx="274" cy="364" r="4"></circle>
              <circle class="dots fill-indigo" cx="364" cy="364" r="4"></circle>
              <circle class="dots fill-indigo" cx="454" cy="364" r="4"></circle>
              <circle class="dots fill-indigo" cx="4" cy="454" r="4"></circle>
              <circle class="dots fill-indigo" cx="94" cy="454" r="4"></circle>
              <circle class="dots fill-indigo" cx="184" cy="454" r="4"></circle>
              <circle class="dots fill-indigo" cx="274" cy="454" r="4"></circle>
              <circle class="dots fill-indigo" cx="364" cy="454" r="4"></circle>
              <circle class="dots fill-indigo" cx="454" cy="454" r="4"></circle>
</svg>
          </div>
        </figure>
      </div>
    </div>
    <!-- End Mockup -->

    <!-- SVG Background Shape -->
    <figure class="ie-half-circle-1-1 w-35 position-absolute top-0 right-0 z-index-n1 mt-n11 mr-n11">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 451 902" style="enable-background:new 0 0 451 902;" xml:space="preserve" class="injected-svg js-svg-injector" data-parent="#SVGHero">
<style type="text/css">
	.half-circle-1-0 {
    fill: none;
    stroke: #FFFFFF;
  }
</style>
        <path class="half-circle-1-0 fill-none stroke-white" stroke-width="164" stroke-miterlimit="10" d="M451,820C247.2,820,82,654.8,82,451S247.2,82,451,82"></path>
</svg>
    </figure>

    <figure class="ie-half-circle-2-1 w-25 position-absolute bottom-0 left-0 z-index-n1 mb-n11 ml-n11">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 451 902" style="enable-background:new 0 0 451 902;" xml:space="preserve" class="injected-svg js-svg-injector" data-parent="#SVGHero">
<linearGradient id="halfCircledID_1" gradientUnits="userSpaceOnUse" x1="323.2045" y1="118.7578" x2="-97.6164" y2="847.6411" gradientTransform="matrix(1 0 0 -1 0 904)">
	<stop class="stop-color-white" offset="0" style="stop-color:#FFFFFF;stop-opacity:0"></stop>
  <stop class="stop-color-indigo" offset="1" style="stop-color:#2D1582"></stop>
</linearGradient>
        <path fill="none" opacity=".125" stroke="url(#halfCircledID_1)" stroke-width="164" stroke-miterlimit="10" d="M0,82c203.8,0,369,165.2,369,369S203.8,820,0,820"></path>
</svg>
    </figure>
    <!-- End SVG Background Shape -->
  </div>
  <!-- End Hero Section -->

  <!-- Features Section -->
  <div class="container space-2">
    <div class="row justify-content-lg-between align-items-lg-center">
      <div class="col-lg-5 order-lg-2 mb-9 mb-lg-0">
        <!-- Description -->
        <h2 class="font-weight-medium">State of the art equipment.<br>State of the art show.
        </h2>
        <p>All of our equipment has been optimized for quick and easy set up saving thousands on labor costs</p>
        <!-- End Description -->

        <!-- List -->
        <ul class="list-unstyled text-secondary">
          <li class="media my-3">
            <div class="d-flex mt-1 mr-2">
              <span class="fas fa-check text-success"></span>
            </div>
            <div class="media-body">
              Verified, up-to-date Cards
            </div>
          </li>
          <li class="media my-3">
            <div class="d-flex mt-1 mr-2">
              <span class="fas fa-check text-success"></span>
            </div>
            <div class="media-body">
              Seamless job search
            </div>
          </li>
          <li class="media my-3">
            <div class="d-flex mt-1 mr-2">
              <span class="fas fa-check text-success"></span>
            </div>
            <div class="media-body">
              Job seekers and employers connect
            </div>
          </li>
        </ul>
        <!-- End List -->
      </div>

      <div class="col-lg-7 order-lg-1">
        <!-- SVG Shape -->
        <figure id="SVGgetAnswered" class=" ie-get-answered">
          <img class="js-svg-injector" style="border-radius: 50px" src="../../assets/website/av-channel-0.jpg" alt="Image Description"
               data-parent="#SVGgetAnswered">
        </figure>
        <!-- End SVG Shape -->
      </div>
    </div>
  </div>
  <!-- End Features Section -->


  <!-- Mockup Block -->
  <div class="container space-bottom-2 space-bottom-md-3">
    <div class="row align-items-lg-center">
      <div class="col-lg-5 mb-7 mb-lg-0">
        <!-- Title -->
        <div class="pr-lg-4">

          <h2 class="h4 font-weight-semi-bold text-primary">Live Events</h2>
          <p class="mb-0">Elevate your live events and wow your audience with our live event production services. Projectors, Screens, LED walls, stage decorations and much more! Our team can help you implement whatever you can dream for a fraction of the cost of in-house AV providers.</p>
        </div>
        <!-- End Title -->
      </div>

      <div id="SVGmarketingStrategy" class="col-lg-7">
        <!-- SVG Icon -->
        <figure class="ie-marketing-strategy">
          <img class="js-svg-injector" style="border-radius: 50px;" src="../../assets/website/live-events.jpg" alt="SVG Illustration"
               data-parent="#SVGmarketingStrategy">
        </figure>
        <!-- End SVG Icon -->
      </div>
    </div>
  </div>
  <!-- End Mockup Block -->

  <!-- Mockup Block -->
  <div class="container space-1">

    <div class="row align-items-lg-center">
      <div class="col-lg-5 order-lg-2 mb-7 mb-lg-0">
        <!-- Title -->
        <div class="pl-lg-4">

          <h2 class="h4 font-weight-semi-bold text-primary">Hybrid Events</h2>
          <p class="mb-0">Combine AV and our software platform and produce the highest quality hybrid events available. Remote presenters, remote attendees, virtual poster sessions, virtual exhibits and more!</p>
        </div>
        <!-- End Title -->
      </div>

      <div id="SVGappDevelopment" class="col-lg-7 order-lg-1 ">
        <!-- SVG Icon -->
        <figure class="ie-app-development">
          <img class="js-svg-injector" style="border-radius: 50px;" src="../../assets/website/hybrid-events.jpg" alt="SVG Illustration"
               data-parent="#SVGappDevelopment">
        </figure>
        <!-- End SVG Icon -->
      </div>
    </div>
  </div>
  <!-- End Mockup Block -->

  <!-- Mockup Block -->
  <div class="container space-top-2 space-top-md-3">
    <div class="row align-items-lg-center">
      <div class="col-lg-5 mb-7 mb-lg-0">
        <!-- Title -->
        <div class="pr-lg-4">

          <h2 class="h4 font-weight-semi-bold text-primary">Virtual Events</h2>
          <p class="mb-0">Wether its using Zoom to bring in remote presenters, or live green-screen production with a virtual audience and virtual presenters we've got you covered!</p>
        </div>
        <!-- End Title -->
      </div>

      <div id="SVGbusinessAnalysis" class="col-lg-7 ">
        <!-- SVG Icon -->
        <figure class="ie-business-analysis">
          <img class="img-fluid" style="border-radius: 50px;" src="../../assets/website/green-screen.jpg" alt="SVG Illustration"
               data-parent="#SVGbusinessAnalysis">
        </figure>
        <!-- End SVG Icon -->
      </div>
    </div>
  </div>
  <!-- End Mockup Block -->
  <!-- Features Section -->
  <div id="SVGelements" class="">
    <!-- SVG Background -->
    <figure class="position-absolute right-0 bottom-0 left-0">
      <img class="js-svg-injector" src="../../assets/svg/components/wave-1-bottom-sm.svg" alt="Image Description"
           data-parent="#SVGelements">
    </figure>
    <!-- End SVG Background -->

    <div class="gradient-half-primary-v3">
      <div class="container space-top-2 space-top-md-3 space-bottom-1">
        <div class="row justify-content-lg-between align-items-lg-start">
          <div class="col-lg-5 mb-7 mb-lg-0">
            <!-- Title -->
            <div class="pr-md-4 mb-4">
              <h2 class="text-primary">Get started <span class="font-weight-semi-bold">TODAY</span></h2>
              <p>Connect with our team today, and start designing a world-class event!</p>
            </div>
            <!-- End Title -->

            <button class="btn btn-soft-primary btn-wide btn-pill transition-3d-hover ml-1 mb-2" type="button" (click)="ctaService.showCTA('17e74dcb-2609-478e-848a-ceffdd2c4df2')">Book a call</button>
          </div>

          <div class="col-lg-6 mt-auto">
            <!-- SVG Icon -->
            <figure class="ie-working-men">
              <img class="js-svg-injector" src="../../assets/svg/illustrations/app-development.svg" alt="SVG Illustration"
                   data-parent="#SVGelements">
            </figure>
            <!-- End SVG Icon -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End Features Section -->

</main>
